module.exports = ".row:nth-child(odd){\r\n    background: #f3f3f3;\r\n  }\r\n\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/sainik-registration/uploads/uploads.component.css
// module id = ./src/app/sainik-registration/uploads/uploads.component.css
// module chunks = main